<HomeNavBar />
<InactivityModal />

<div class="birthdays-page">
  <section class="birthdays-hero">
    <div class="birthdays-hero-copy">
      <button
        class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn"
        type="button"
        @click="$router.back()"
      >
        <i class="bi bi-chevron-left fs-5"></i>
      </button>

      <div class="d-flex align-items-center gap-3 mt-2">
        <span class="birthdays-hero-icon d-inline-flex align-items-center justify-content-center">
          <i class="bi bi-gift-fill" aria-hidden="true"></i>
        </span>
        <div class="min-w-0">
          <span class="birthdays-kicker">Birthday calendar</span>
          <h2 class="birthdays-title mb-1">Upcoming Birthdays</h2>
          <p class="birthdays-subtitle mb-0">
            Keep track of today's celebrations and the birthdays coming up next.
          </p>
        </div>
      </div>
    </div>

    <div class="birthdays-hero-panel">
      <div class="birthdays-stats">
        <div>
          <span class="birthdays-stat-value">{{ todayBirthdays.length }}</span>
          <span class="birthdays-stat-label">Today</span>
        </div>
        <div>
          <span class="birthdays-stat-value">{{ upcomingBirthdays.length }}</span>
          <span class="birthdays-stat-label">Upcoming</span>
        </div>
      </div>

      <button class="birthdays-next-card" v-if="nextBirthday" type="button" @click="view_profile(nextBirthday)">
        <span class="text-muted text-xs fw-bold">Next celebration</span>
        <div class="d-flex align-items-center gap-2 min-w-0">
          <img :src="get_profile_avatar(nextBirthday)" :alt="get_profile_name(nextBirthday)" class="birthdays-person-avatar" />
          <div class="min-w-0">
            <div class="fw-bold">{{ get_profile_name(nextBirthday) }}</div>
            <div class="birthdays-next-date">
              {{ daysUntilBirthday(nextBirthday.date_of_birth) === 0 ? 'Today' : `${daysUntilBirthday(nextBirthday.date_of_birth)} days away` }}
            </div>
          </div>
        </div>
      </button>
    </div>
  </section>

  <div class="birthdays-scroll-area">
    <div v-if="loading" class="birthdays-loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 mb-0 text-muted">Loading upcoming birthdays...</p>
    </div>

    <div v-else>
      <section v-if="todayBirthdays.length" class="birthdays-section birthdays-section-featured">
        <div class="birthdays-section-heading">
          <div class="d-flex align-items-center gap-2 min-w-0">
            <span class="birthdays-section-icon"><i class="bi bi-stars"></i></span>
            <div class="min-w-0">
            <h5 class="mb-0 fw-bold text-dark">Today</h5>
            <p class="mb-0 text-muted text-xxs">Wish them a happy birthday.</p>
            </div>
          </div>
          <span class="birthdays-section-count d-inline-flex align-items-center justify-content-center fw-bold">{{ todayBirthdays.length }}</span>
        </div>

        <div class="birthdays-grid birthdays-grid-today">
          <button
            v-for="profile in todayBirthdays"
            :key="profile.id"
            class="birthdays-person-card birthdays-person-card-today"
            type="button"
            @click="view_profile(profile)"
          >
            <span class="birthdays-person-badge">Today</span>
            <img
              :src="get_profile_avatar(profile)"
              :alt="get_profile_name(profile)"
              class="birthdays-person-avatar"
            />
            <span class="birthdays-person-info">
              <span class="fw-bold">{{ get_profile_name(profile) }}</span>
              <span class="birthdays-person-date">
                <i class="bi bi-calendar-heart me-1"></i>{{ formatDate(profile.date_of_birth) }}
              </span>
            </span>
          </button>
        </div>
      </section>

      <section v-if="upcomingBirthdays.length" class="birthdays-section mt-md-3 mt-2">
        <div class="birthdays-section-heading">
          <div class="d-flex align-items-center gap-2 min-w-0">
            <span class="birthdays-section-icon"><i class="bi bi-calendar2-week"></i></span>
            <div class="min-w-0">
            <h5 class="mb-0 fw-bold text-dark">Coming Up</h5>
            </div>
          </div>
          <span class="birthdays-section-count d-inline-flex align-items-center justify-center fw-bold">{{ upcomingBirthdays.length }}</span>
        </div>

        <div class="birthdays-grid">
          <button
            v-for="profile in upcomingBirthdays"
            :key="profile.id"
            class="birthdays-person-card"
            type="button"
            @click="view_profile(profile)"
          >
            <span class="birthdays-person-badge">{{ daysUntilBirthday(profile.date_of_birth) }} days</span>
            <img
              :src="get_profile_avatar(profile)"
              :alt="get_profile_name(profile)"
              class="birthdays-person-avatar"
            />
            <span class="birthdays-person-info">
              <span class="fw-bold truncate-text text-xs">{{ get_profile_name(profile) }}</span>
              <span class="text-muted text-xxs">
                <i class="bi bi-calendar-heart me-1"></i>{{ formatDate(profile.date_of_birth) }}
              </span>
            </span>
          </button>
        </div>
      </section>

      <div v-if="!todayBirthdays.length && !upcomingBirthdays.length" class="birthdays-empty">
        <span class="birthdays-empty-icon d-inline-flex align-items-center justify-content-center">
          <i class="bi bi-calendar-heart" aria-hidden="true"></i>
        </span>
        <h5 class="fw-bold text-dark">No upcoming birthdays found</h5>
      </div>
    </div>
  </div>
</div>

<StickyNav />
